import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
const CART_URL = 'https://www.kmsinrendirse.shop/cart/add?id=51999668764955&quantity=1';
function trackAddToCart() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart');
  }
}
export function FinalCtaSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 px-4 bg-gradient-to-b from-navy to-navy-light" data-id="element-50">
      <div className="max-w-4xl mx-auto text-center" data-id="element-51">
        <motion.h2 className="text-4xl md:text-6xl font-black mb-8 leading-tight" initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-52">
          Si llegaste hasta acá,{' '}
          <span className="text-accent" data-id="element-53">es porque ya lo sabés</span>
        </motion.h2>

        <motion.p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-54">
          Podés seguir intentando solo y abandonar en unos días…
          <br data-id="element-55" />
          <span className="text-white font-semibold" data-id="element-56">
            O podés tener un sistema que finalmente te lleve hasta el final.
          </span>
        </motion.p>

        <motion.p className="text-2xl md:text-3xl font-bold text-white mb-12" initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-57">
          La decisión es tuya. Pero el momento es ahora.
        </motion.p>

        <motion.a href={CART_URL} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block bg-accent hover:bg-accent-dark text-white px-16 py-6 rounded-2xl font-black text-2xl md:text-3xl transition-all hover:scale-105 shadow-2xl shadow-accent/40 mb-8" initial={{
        opacity: 0,
        scale: 0.9
      }} animate={isInView ? {
        opacity: 1,
        scale: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.6
      }} whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.98
      }} data-id="element-58">
          EMPEZAR HOY
        </motion.a>

        <motion.p className="text-gray-400 text-sm" initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.6,
        delay: 0.8
      }} data-id="element-59">
          Acceso inmediato • Descarga digital • Oferta por tiempo limitado
        </motion.p>
      </div>
    </section>;
}